import React, { useEffect } from "react";
import { isArray } from "lodash";
import { appendClassName } from "../../../../helpers/view-helpers";
import { resultFieldCells } from "../../../config/faq-config-helper";
import { withSelectedResult } from "../../../providers/ResultSelectContext";

const seprator = ",";
const getSeparatedValues = textOrArray => {
  return isArray(textOrArray) ? textOrArray.join(seprator + " ") : textOrArray;
};

const ListItem = ({ result, isSelectedResultId, setSelectedResultIds }) => {
  useEffect(() => {
    setSelectedResultIds(r => ({
      ...r,
      [result.id.raw]: r[result.id.raw] || false
    }));
  }, [result.id.raw]);
  return (
    <tr
      className={appendClassName(
        isSelectedResultId(result.id.raw) ? "is-selected" : "",
        result.id.raw
      )}
      key={result.id.raw}
    >
      {resultFieldCells
        .filter(({ hidden }) => !hidden)
        .map((cell, index) => {
          const Field = cell.Cell
            ? cell.Cell
            : ({ result }) => (
                <td>
                  {result[cell.field]
                    ? getSeparatedValues(result[cell.field].raw)
                    : ""}
                </td>
              );
          return <Field key={index} {...{ result }} />;
        })}
    </tr>
  );
};

const mapContextToProps = ({ isSelectedResultId, setSelectedResultIds }) => ({
  isSelectedResultId,
  setSelectedResultIds
});

export default withSelectedResult(mapContextToProps)(ListItem);
